import React from 'react'
import PropTypes from 'prop-types'
import { isIndeterminate } from '../utils'
import { StyledBqOption, StyledBqCheckbox } from './styles'

/**
 * @typedef {Object} InnerValue
 * @property {string} value
 * @property {InnerValue[]?} innerValues
 */

/**
 * @typedef {Object} Option
 * @property {string} value
 * @property {InnerValue[]?} innerValues
 */

/**
 * @typedef {Object} OptionProps
 * @property {Option} option
 * @property {string[]} value
 * @property {number?} level
 * @property {boolean?} isParentSelected
 * @property {string} defaultOption
 */

/**
 * @param {OptionProps} props
 * @returns {import('react').ReactElement}
 */
export const Option = ({ level = 0, isParentSelected = false, option, value, defaultOption }) => {
  const isChecked = isParentSelected || value.includes(option.value)
  return (<>
    <StyledBqOption value={option.value} disabled={option.value === defaultOption}>
      <StyledBqCheckbox
        name='name'
        level={level}
        value={option.value}
        indeterminate={isIndeterminate(value, option)}
        checked={isChecked}
      />
      {option.value}
    </StyledBqOption>
    {option.innerValues?.map((innerValue) =>
      <Option
        key={innerValue.value}
        value={value}
        level={level + 1}
        option={innerValue}
        isParentSelected={isChecked}
        disabled={innerValue.value === defaultOption}
        defaultOption={defaultOption}
      />)}
  </>)
}

const optionShape = {
  value: PropTypes.string.isRequired
}

optionShape.innerValues = PropTypes.arrayOf(PropTypes.shape(optionShape))

Option.propTypes = {
  option: PropTypes.shape(optionShape),
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  level: PropTypes.number,
  isParentSelected: PropTypes.bool,
  defaultOption: PropTypes.string
}

export default Option
